export const INITIALISE_MAP = 'INITIALISE_MAP'
export const SET_MAP_BOUNDS = 'SET_MAP_BOUNDS'
